/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExtraItemResource } from './extraItemResource';


export interface ExtraTypeResource { 
    total: number;
    items: Array<ExtraItemResource>;
}

